<template>
    <div class="topNavBar">
        <button class="burger-bar-btn"
                @click="onMenuBurgerClick()">
            <span></span>
            <span></span>
            <span></span>
        </button>

        <div class="admin_add_question_menu" v-if="userInfo.role == 'admin'">
            <button @click="generatePdfClick" style="color: white; background: #00000000; margin-left: 10px;">
                PDF template
            </button>
            <button @click="adminAddPlaceClick" v-if="true">
                Link question
            </button>
        </div>

        <div class="nav_center_section">
            <div v-if="!$route.meta.adminPanel" class="main_nav">
            </div>
        </div>

        <div class="nav_search_section">
            <button class="search" v-if="showSearch" @click="openSearch">
                <img src="@/assets/re/search_ico.png" alt="">
            </button>
        </div>

        <div class="generating_pdf_section" v-if="$route.name === 'adminPanel'">
            <div class="generating-pdf" v-if="pdfStatus.progress">
                <b-button variant="primary" @click="togglePdfModal(true)">
                    <span v-if="pdfStatus.status === 'done'" class="d-none d-sm-inline">PDF Link</span>
                    <span v-else>
						<span class="d-none d-sm-inline">PDF Generating...</span>
						<span class="d-sm-none">Generating</span>
					</span>
                    <b-spinner v-if="pdfStatus.status !== 'done'" small></b-spinner>
                    <i v-if="pdfStatus.status === 'done'" class="fa fa-download"></i>
                </b-button>
            </div>
        </div>

        <div class="seach-block" :class="{
			open: activeSearch, 
			empty: autocompleteCollection.length === 0,
			'my-places': $route.name === 'list' && myPlaceChekbox
			}">
            <div v-show="activeSearch">
                <span class="seach-submit" @click="onInputSearch"></span>

                <autocomplete
                        id="search"
                        :value="searchQuery"
                        :items="autocompleteCollection"
                        :get-label="getLabel"
                        :component-item='searchTemplate'
                        :keep-open="isOpenSearch"
                        @item-clicked="selectPlace"
                        @change="onInputSearch"
                >
                </autocomplete>

                <span class="close-search" @click="onCloseSearch">
					<i class="icon-close-search"></i>
				</span>
            </div>

            <PlaceMarkerInfoModal
                    shadowBlock
                    :display="displayPlaceInfoModal"
                    :place-info="selectedSearchPlace"
            >
            </PlaceMarkerInfoModal>
        </div>
    </div>
</template>

<script>
    // Import plugins
    import Autocomplete from 'v-autocomplete'
    import 'v-autocomplete/dist/v-autocomplete.css'
    import {mapActions, mapMutations, mapState} from 'vuex'
    // Import components
    import PlaceMarkerInfoModal from '@/components/widgets/placeMarkerInfoModal'
    import SearchTemplate from '@/components/blocks/SearchTemplate'
    import MenuBar from '@/components/widgets/menuBar'
    // Import heplers
    import logAnalyticsEvent from '@/helpers/analytics'

    export default {
        name: 'ToolBar',

        components: {
            MenuBar,
            PlaceMarkerInfoModal,
            Autocomplete
        },

        data() {
            return {
                autocompleteCollection: [],
                isOpenSearch: false,
                selectedSearchPlace: null,
                displayPlaceInfoModal: false,
                searchTemplate: SearchTemplate,
                searchQuery: '',
            }
        },

        computed: {
            ...mapState({
                userInfo: state => state.auth.userInfo,
                myPlaceChekbox: state => state.place.myPlaceChekbox,
                pdfStatus: state => state.pdf.pdfStatus,
                activeSearch: state => state.search.activeSearch,
                searchText: state => state.search.searchText,
            }),

            showSearch() {
                const listPage = this.$route.name === 'list'
                return listPage
            }
        },

        methods: {
            ...mapActions({
                fetchPlace: 'place/fetchPlace',
                fetchPlacesList: 'place/fetchPlacesList'
            }),

            ...mapMutations({
                setDetailedMapPlace: 'place/setDetailedMapPlace',
                setSearchText: 'search/setSearchText',
                setPlacePage: 'place/setPlacePage',
                setRates: 'place/setRates',
                togglePdfModal: 'pdf/togglePdfModal',
                toggleSearchPanel: 'search/toggleSearchPanel',
            }),

            onListLinkClick() {
                logAnalyticsEvent('toolbar_list_btn_click')
            },

            onCloseSearch() {
                this.isOpenSearch = false
                this.toggleSearchPanel(false)
                this.displayPlaceInfoModal = false
                this.autocompleteCollection = []
                this.$store.commit("setSessionToken", null)

                this.searchQuery = ''
                this.setSearchText('')
                this.setPlacePage(1)
            },

            getLabel(item) {
                if (item) {
                    return item.main_text || item
                }
                return ''
            },

            adminAddPlaceClick() {
                this.$router.push({name: 'adminAddPlaceQFlow', params: {}})
            },

            generatePdfClick() {
                this.$router.push({name: 'pdfGeneration', params: {}})
            },

            onInputSearch(searchText) {
                this.searchQuery = searchText
                this.setSearchText(searchText)
            },

            // async onSearchAutocomplete(searchText) {
            //     if (!this.myPlaceChekbox || this.$route.name !== 'list') {
            //         let response = await this.searchPlaceAutocomplete(searchText)
            //         if (response.items.length === 0) response.items.push({
            //             main_text: 'There is no results.',
            //             secondary_text: 'Plese try again'
            //         })
            //         this.autocompleteCollection = response.items
            //         this.isOpenSearch = true
            //     }
            // },

            async selectPlace(place) {
                // if (this.$route.name === 'map') logAnalyticsEvent('map_place_in_search_click')
                if (this.$route.name === 'list') logAnalyticsEvent('places_place_in_search_click')


                this.isOpenSearch = false
                const placeId = place.placeId ? place.placeId : place.id
                if (this.$route.name === 'list') {
                    this.isOpenSearch = true
                }

                this.autocompleteCollection = []
                const responce = await this.fetchPlace(placeId)
                this.$store.commit("setSessionToken", null)
                if (this.$route.name === 'list') {
                    this.displayPlaceInfoModal = true
                    this.selectedSearchPlace = responce
                }

                // if (this.$route.name === 'map') {
                //     this.setDetailedMapPlace(responce)
                // }

            },
            onMenuBurgerClick() {
                this.$store.commit('auth/toggleAdminMenu')
            },
        },

        mounted() {
            if (this.searchText.length) {
                this.searchQuery = this.searchText
                this.getLabel(this.searchText)

                if (!this.myPlaceChekbox) {
                    this.isOpenSearch = true
                    // this.onSearchAutocomplete(this.searchQuery)
                }
            }
        }
    }
</script>

<style>

.burger-bar-btn {
    background: none;
    border: none;
}
.burger-bar-btn span {
    width: 20px;
    height: 2px;
    background: #fff;
    margin: 4px 0;
    display: block;
}

    .my-places .v-autocomplete-list {
        display: none;
    }

    .nav_center_section {
        width: 55%;
        max-width: 250px;
        display: flex;
        justify-content: space-around;
    }

    .main_nav {
        flex: 1 1;
        display: flex;
        justify-content: space-between;
        color: #ffffff;
    }

    .nav_center_section .nav_center_item {
        width: 45%;
        font-size: 0.9em;
        text-decoration: none;
        position: relative;
    }

    .nav_center_section a {
        color: #fff;
        text-decoration: none;
    }

    .nav_center_section a.router-link-active:after {
        content: '';
        position: absolute;
        bottom: -0.2em;
        left: 0;
        right: 0;
        height: 0.12em;
        width: 100%;
        background: #fff;
    }

    .nav_search_section {
        display: flex;
        flex-direction: row;
    }

    .generating_pdf_section {
        width: 100%;
        justify-content: flex-end;
        text-align: right;
    }

    .admin_add_question_menu {
        width: 100px;
        display: flex;
    }

    .generating-pdf .spinner-border-sm {
        margin: 0 5px;
    }

    button.search {
        border: none;
        background: none;
    }

    /* Search block */
    input::-webkit-search-decoration,
    input::-webkit-search-cancel-button,
    input::-webkit-search-results-button,
    input::-webkit-search-results-decoration {
        display: none;
    }

    .seach-block {
        position: absolute;
        top: 0;
        right: 0;
        width: 15%;
        opacity: 0.7;
        transition: all 0.6s ease;
    }

    .seach-block.open {
        width: 100%;
        opacity: 1;
    }

    .seach-block .v-autocomplete-input {
        height: 64px;
        border-radius: 0px;
        padding-left: 50px;
        padding-right: 50px;
        box-shadow: none;
        border: none;
        font-size: 20px;
        font-weight: 700;
        width: 100%;
        outline: none;
    }

    .seach-block .v-autocomplete-input:focus {
        outline: none;
    }

    .close-search {
        position: absolute;
        top: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: translate(0, -50%) scale(1);
        right: 15px;
        width: 25px;
        height: 25px;
        z-index: 20;
        font-weight: 100;
        color: rgb(80, 80, 80);
        transition: color 0.25s ease;
        cursor: pointer;
    }

    .close-search:hover {
        color: rgb(0, 0, 0);
    }

    .seach-submit {
        position: absolute;
        top: 50%;
        left: 15px;
        z-index: 20;
        margin-top: -12px;
        width: 24px;
        height: 24px;
        background: url("../../assets/images/ic_search.png") 50% no-repeat;
        cursor: pointer;
    }

    .seach-block .v-autocomplete-list {
        height: calc(100vh - 64px);
        max-height: 100vh;
        background: #fff;
        text-align: left;
        width: 100%;
        box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.11);
    }

    .v-autocomplete-list-item {
        transition: all 0.2s ease;
    }

    .icon-close-search {
        display: inline-block;
        width: 24px;
        height: 24px;
        background: url('../../assets/icons/ic_close_white.svg') 50% no-repeat;
    }

    button.search img {
        width: 1em;
    }

    .navbar.transparent.waypoint-bg {
        background: #2F2F2F !important;
        transition: background .3s ease-in-out;
    }

    @media screen and (min-width: 768px) {
        .generating-pdf .fa-download {
            margin-left: 10px;
        }
    }

    @media screen and (max-width: 768px) {
        .pdf-section {
            width: 100%;
            justify-content: flex-end;
        }
    }
</style>
<style scoped>
.topNavBar {
    margin-top: 0;
    background: #4a4a4a;
    display: flex;
    align-items: center;

    position: relative;
    top: 0;
    left: 0;
    right: 0;
    z-index: 9;

    text-align: center;
    height: 4em;
    padding: 0.5rem 1rem;
}
</style>